import api from './api';

class SubscriptionService {
  async listSubscriptions() {
    const response = await api.get('/subscription/list');
    const data = response.data;
    if (Array.isArray(data)) return data;
    return data?.subscriptions || [];
  }

  async cancelSubscription(subscriptionId, cancelAtPeriodEnd = false) {
    const response = await api.post(`/subscription/${subscriptionId}/cancel`, null, {
      params: { cancelAtPeriodEnd }
    });
    return response.data;
  }
}

const subscriptionService = new SubscriptionService();
export default subscriptionService;
export { subscriptionService };